import script from "./Tooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tooltip.vue?vue&type=script&lang=ts&setup=true"

import "./Tooltip.vue?vue&type=style&index=0&id=1f46ec3c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f46ec3c"]])

export default __exports__